import React from 'react';
import styled from 'styled-components';
import Select from '../../../dev/Select';
import { connect } from 'react-redux'
import countryOptions from '../../../dev/countryOptions'

const CountrySearch = (props) => {
    const { countrySelect, messages } = props
    return (
        <CountryWrap>
            <Title>{messages.country}：</Title>
            <Select
                name="form-field-name"
                onChange={countrySelect}
                options={countryOptions}
                placeholder={'All(default)'} 
            />
        </CountryWrap>
    )
}
const mapStateToProps = state => {
    return {
        messages: state.Messages
    }
}
export default connect(mapStateToProps)(CountrySearch);
const Title = styled.div`
    margin-right: 20px;
    font-size: 14px;
    font-weight: 500;
    line-height: 28px;
    color: #979797;
`
const CountryWrap = styled.div`
    display: flex;
    align-items: center;    
    margin: 20px 20px 0 0;
`


// WEBPACK FOOTER //
// ./src/InfoList/Search/dev/CountrySearch.js